import {
  Component,
  Input,
  ViewChild,
  OnInit,
  OnDestroy,
  NgZone,
} from "@angular/core";

import { Subscription } from "rxjs";

import { ModalDirective } from "ngx-bootstrap/modal";

import {
  Document,
  DocumentService,
  Attribute,
  AttributeMaps,
  DocumentPartMap,
  AttributeService,
} from "./../../../../shared/index";
import { DocumentListComponent } from "./../../../index";

@Component({
  selector: "advanced-document-filter",
  templateUrl: "./advanced-document-filter.html",
  standalone: false,
})
export class AdvancedDocumentFilterComponent {
  @ViewChild("advancedDocumentFilterModal") documentFilterModal: ModalDirective;

  public attributes: Attribute[] = [];

  public selectedModels: DocumentPartMap[] = [];
  public selectedPoweredBys: DocumentPartMap[] = [];
  public selectedSuites: DocumentPartMap[] = [];
  public selectedLanguages: DocumentPartMap[] = [];

  public fileName = "";
  public filterApplied = false;

  private subscriptions: Subscription[] = [];

  constructor(
    private _documentService: DocumentService,
    private _ngZone: NgZone,
    private _attributeService: AttributeService
  ) {}

  public open(): void {
    this.documentFilterModal.show();
  }

  public close(): void {
    this.documentFilterModal.hide();
  }

  public clearFilter(): void {
    this.fileName = "";
    this.selectedModels = [];
    this.selectedPoweredBys = [];
    this.selectedSuites = [];
    this.selectedLanguages = [];
    this.filterApplied = false;
  }

  public applyFilter(): void {
    if (
      this.fileName != "" ||
      this.selectedModels.length > 0 ||
      this.selectedPoweredBys.length > 0 ||
      this.selectedSuites.length > 0 ||
      this.selectedLanguages.length > 0
    ) {
      this.filterApplied = true;
    } else {
      this.filterApplied = false;
    }
    this._documentService.applyFilter(
      this.fileName,
      this.selectedModels,
      this.selectedPoweredBys,
      this.selectedSuites,
      this.selectedLanguages,
      true,
      true
    );
    this.documentFilterModal.hide();
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this._attributeService.attributesChange.subscribe(
        (attributes: Attribute[]) => {
          this.attributes = attributes;
          for (const attribute of this.attributes) {
            attribute.Maps.init();
            this._attributeService.getMaps(attribute.Id);
          }
        }
      )
    );
    this.subscriptions.push(
      this._attributeService.attributeMapChange.subscribe(
        (attributeMaps: AttributeMaps) => {
          this._ngZone.run(() => {
            const attribute: Attribute = this.attributes.filter(
              (value) => value.Id == attributeMaps.AttributeId
            )[0];
            attribute.Maps.init();
            for (const map of attributeMaps.Maps) {
              attribute.Maps.update(map, true);
            }
          });
        }
      )
    );

    this._attributeService.getAttributes();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
